/*
 * @Date: 2023-11-03 14:13:51
 * @LastEditors: lihwang
 * @LastEditTime: 2023-11-14 16:25:58
 * @FilePath: /ckb-mall-web/src/common/CKBLayout/modules/GoodsItem/index.tsx
 * @Description:
 * @Author: lihwang
 */
import { useNavigate } from 'react-router-dom';
import { Image } from 'antd';
import { useAtom } from 'jotai';
import { useState } from 'react';
import { useRequest } from 'ahooks';
import { PLAT_TYPE } from '@/const/enum';
import { ProductKeywordRespDTO } from '@/service/goods';
import { toLogin, checkLogin, toTheCkb } from '@/config/request/login';
import FavoriteProduct from '@/common/icons/FavoriteProduct';
import CollectionSuccessful from '@/common/icons/CollectionSuccessful';
import { BACK_UP_IMG } from '@/const/staticURL';
import { request } from '@/config/request';
import { urlAddChannel } from '@/utils';
import { ShowModal } from '@/model';
import { atomRequestCustomerDetail } from '@/App';
import styles from './index.module.scss';
interface ExtendProductDTO extends ProductKeywordRespDTO {
    productLowestPrice?: number;
    systemProductTitle?: string;
    originalProductTitleJa?: string;
}
interface Props {
    product: ExtendProductDTO;
    showGoBackPrice?: boolean;
    isLogin?: boolean;
    showTags?: boolean;
    openToAgentModal?: () => void;
}
const Wares = ({
    product = {},
    showGoBackPrice,
    isLogin,
    showTags,
    openToAgentModal
}: Props) => {
    const [customerDetail] = useAtom(atomRequestCustomerDetail);
    const [isFavorite, setIsFavorite] = useState(product.favoriteFlag === 1);
    const [, writeShowModal] = useAtom(ShowModal.showModal);
    const { runAsync: apiAddFavoriteProduct } = useRequest(
        request.goods.favoriteProduct.postFavoriteProduct,
        {
            manual: true
        }
    );
    const { runAsync: apiCancelFavoriteProduct } = useRequest(
        request.goods.favoriteProduct.cancel,
        {
            manual: true
        }
    );
    const goGoodsDetail = async (product) => {
        if (isLogin) {
            if (product.productPurchaseType) {
                openToAgentModal && openToAgentModal();
            } else {
                const url = `/goods?productCode=${product.productCode}`;
                window.open(urlAddChannel(url));
            }
        } else {
            // 未登录先跳转登录，回来后展示弹窗
            // if (product.productPurchaseType === 1) {
            //     window.sessionStorage.setItem(
            //         'showDirectToAgentModalProductCode',
            //         product.productCode
            //     );
            // }

            // window.location.href = toLogin();
            writeShowModal(true);
        }
    };
    const favoriteClick = async () => {
        if (isFavorite) {
            const res = await apiCancelFavoriteProduct({
                productCode: product.productCode
            });
            if (res.success) {
                setIsFavorite(!isFavorite);
            }
        } else {
            const {
                platformType,
                productCode,
                productMainImg,
                productSellPriceJa,
                productTitle
            } = product;
            const params = {
                platformType,
                productCode,
                productMainImg,
                productSellPrice: productSellPriceJa,
                productTitle
            };
            const res = await apiAddFavoriteProduct({
                ...params,
                favoriteProductType: PLAT_TYPE.DC
            });
            if (res.success) {
                setIsFavorite(!isFavorite);
            }
        }
    };
    return (
        <div
            className={styles.goods}
            onClick={() => goGoodsDetail(product)}
            style={{
                opacity: `${product.availableQuantity === 0 ? '0.7' : '1'}`
            }}
        >
            {product.availableQuantity === 0 ? (
                <div className={styles.soldOut}>
                    <div className={styles.txt}>{window._$m.t('售罄')}</div>
                </div>
            ) : null}
            {Boolean(product.productPurchaseType) &&
            Boolean(!customerDetail?.membership?.templateLevel) ? (
                <div className={styles.soldOut}>
                    <div className={styles.agentText}>
                        {window._$m.t('代采专属商品')}
                    </div>
                </div>
            ) : null}
            <div
                style={{
                    opacity: `${
                        Boolean(product.productPurchaseType) &&
                        Boolean(!customerDetail?.membership?.templateLevel)
                            ? '0.7'
                            : '1'
                    }`
                }}
            >
                <Image
                    preview={false}
                    fallback={BACK_UP_IMG}
                    className={styles.img}
                    src={product?.productMainImg}
                    alt=""
                />
                <div className={styles.name}>
                    {product.productTitle ||
                        product.systemProductTitle ||
                        product.originalProductTitleJa}
                </div>
            </div>

            {/* 右上角代采图标 */}
            {Boolean(product.productPurchaseType) && (
                <span className={styles.agentTag}>
                    {window._$m.t('代采特惠')}
                </span>
            )}
            {showTags ? (
                <div className={styles.tag}>
                    {showGoBackPrice ? (
                        <span>{window._$m.t('工場直渡し価格')}</span>
                    ) : null}
                </div>
            ) : null}
            {isLogin ? (
                <div className={styles.prices}>
                    {product.productPurchaseType !== 1 ? (
                        <span>
                            {product.productSellPriceJa ||
                                product.productLowestPrice}
                            {window._$m.t('円')}
                        </span>
                    ) : (
                        <span>
                            <span className="text-[12px] font-normal">
                                {window._$m.t('低至')}
                            </span>
                            <span className="text-[15px] mx-[2px]">
                                {product.sellPrice}
                                {window._$m.t('元')}
                            </span>
                            <span className="text-[12px] font-normal">{`(${window._$m.t(
                                '约'
                            )}${product.productSellPriceJa}${window._$m.t(
                                '円'
                            )})`}</span>
                            <span
                                className="float-right relative top-[4px]"
                                style={{
                                    color: isFavorite ? '#FF5010' : '#999999'
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    favoriteClick();
                                }}
                            >
                                {isFavorite ? (
                                    <CollectionSuccessful
                                        width={18}
                                        height={18}
                                    />
                                ) : (
                                    <FavoriteProduct width={18} height={18} />
                                )}
                            </span>
                        </span>
                    )}
                </div>
            ) : (
                <div className={styles.viewPrices}>
                    {window._$m.t('免费注册查看价格')}
                </div>
            )}
        </div>
    );
};
export default Wares;
